import React from 'react';
export function Header() {
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-212">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-213">
        <div className="flex items-center" data-id="element-214">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vNaw9VnykaT7Gz7PaRPUTw/ChatGPT_Image_Oct_29__2025__08_12_09_PM-removebg-preview.png" alt="Padel Club Review" className="h-12" data-id="element-215" />
        </div>
        <a href="https://padelguard.co.uk/products/padel-elbow-guards" target="_blank" rel="noopener noreferrer" className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 px-6 rounded-lg transition-colors" data-id="element-216">
          Shop #1 Pick
        </a>
      </div>
    </header>;
}